export const GOOGLE_TTS_API_KEY = 'AIzaSyATYDQMA9O9_xN5HZwCHfVa0o2HE8dMstA';
export const arabicRegex = /[\u0600-\u06FF]/;
export const SILENCE_TIMEOUT = 5000;
export const languageOptions = [
    { code: 'en-US', label: 'English', flag: '🇺🇸' },
    { code: 'ar-SA', label: 'العربية', flag: '🇸🇦' }
];